import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import moment from "moment";
import { Select, MenuItem, InputLabel } from "@material-ui/core";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
// import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
// import IconButton from "@material-ui/core/IconButton";
// import Icon from "@material-ui/core/Icon";
// import Tooltip from "@material-ui/core/Tooltip";
// import Switch from "@material-ui/core/Switch";
// import green from "@material-ui/core/colors/green";
// import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";
import { Button, CardContent } from "@material-ui/core";
import { Form } from "react-bootstrap";
import moment from "moment-timezone";

moment.tz.setDefault("Atlantic/Bermuda");

class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flightName: "",
      flightNo: "",
      source: "",
      sourceCode: "",
      destination: "Bermuda",
      destinationCode: "BM",
      isEdit: false,
      addCategory: false,
      flightData: null,
      selectedDate: null,
      filterDate: null,
      recurring: "",
    };
  }

  componentDidMount = () => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    let flightId = this.props.match.params.id;
    // let flightId = window.location.pathname.split("/")[3];
    // debugger;
    let isEdit = window.location.pathname.split("/")[2] === "editFlight";

    let addCategory = window.location.pathname.split("/")[2] === "addFlight";
    // console.log(isEdit, window.location.pathname.split("/")[2], addCategory);
    this.setState({ isEdit, addCategory });
    // this.props.fetchUsers()
    // this.props.getCustomerData();

    axios
      .get(`${domain}/setting/flight/${flightId}`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          const filterDate = moment(
            new Date(res.data.data.flight_date),
            "LLL"
          ).add(4, "h");
          this.setState({
            flightData: res.data.data,
            flightName: res.data.data.name,
            flightNo: res.data.data.flight_id,
            source: res.data.data.source,
            sourceCode: res.data.data.source_code,
            destination: res.data.data.destination,
            destinationCode: res.data.data.destination_code,
            recurring: res.data.data.recurring,
            selectedDate: filterDate,
            filterDate,
          });
        }
      })
      .catch((error) => {});
  };

  submitForm = (e) => {
    e.preventDefault();
    let flightExDate = moment(this.state.filterDate);
    //console.log("iiiiiiiii",moment(this.state.filterDate),this.state.selectedDate)

    let body = {
      name: this.state.flightName,
      flight_date: flightExDate,
      flight_id: this.state.flightNo,
      source: this.state.source,
      source_code: this.state.sourceCode,
      destination: this.state.destination,
      destination_code: this.state.destinationCode,
      recurring: this.state.recurring,
    };

    if (!(this.state.sourceCode && this.state.sourceCode.length < 4)) {
      return toastr.error("Airport code should be 3 characher long.");
    }

    if (!this.state.filterDate) {
      return toastr.error("Please Select Flight Date!");
    }
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    if (this.state.isEdit) {
      let flightData = this.state.flightData;
      console.log(e);
      axios
        .put(`${domain}/setting/flight/${flightData._id}`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Flight Updated Successfully!");
            this.props.history.goBack();
          }
        })
        .catch((error) => {});
    } else {
      axios
        .post(`${domain}/setting/flight`, body, config)
        .then((res) => {
          if (res.data.statusCode === 200 || res.data.statusCode === 201) {
            toastr.success("Flight Added Successfully!");

            this.props.history.goBack();
          }
        })
        .catch((error) => {
          console.log("hi");
        });
    }
  };

  handleChange = (event) => {
    //console.log(event.target.value);
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  changeRecurring = (e) => {
    this.setState({
      recurring: e && e.target.value,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      category,
      isEdit,
      addCategory,
      filterDate,
      flightData,
      flightName,
      flightNo,
      source,
      sourceCode,
      destination,
      destinationCode,
      recurring,
      selectedDate,
    } = this.state;
    return (
      <div>
        <Card>
          <CardContent>
            <Form onSubmit={this.submitForm}>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="flightName"
                  id="flightName"
                  label="Flight"
                  type="name"
                  disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={flightName}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="flightNo"
                  id="flightNo"
                  label="Flight No"
                  type="text"
                  disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={flightNo}
                  style={{ marginBottom: "20px" }}
                  required
                />
              </GridItem>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="source"
                  id="source"
                  label="Airport Location"
                  type="text"
                  disabled={!isEdit && !addCategory}
                  onChange={this.handleChange}
                  fullWidth
                  value={source}
                  style={{ marginBottom: "20px" }}
                  required
                />
                <GridItem xs={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    name="sourceCode"
                    id="sourceCode"
                    label="Airport Code"
                    type="text"
                    disabled={!isEdit && !addCategory}
                    onChange={this.handleChange}
                    fullWidth
                    value={sourceCode}
                    style={{ marginBottom: "20px" }}
                    required
                    inputProps={{ maxLength: 3 }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <TextField
                    //autoFocus
                    margin="dense"
                    name="destination"
                    id="destination"
                    label="Destination"
                    type="text"
                    disabled={!isEdit && !addCategory}
                    //onChange={this.handleChange}
                    fullWidth
                    value={destination}
                    style={{ marginBottom: "20px" }}
                    required
                  />
                </GridItem>
                <GridItem xs={12}>
                  <TextField
                    //autoFocus
                    margin="dense"
                    name="destinationCode"
                    id="destinationCode"
                    label="Destination Code"
                    type="text"
                    disabled={!isEdit && !addCategory}
                    //onChange={this.handleChange}
                    fullWidth
                    value={destinationCode}
                    style={{ marginBottom: "20px" }}
                    required
                  />
                </GridItem>
                <GridItem md={12}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      width: "60%",
                    }}
                  >
                    <div>Recurring</div>
                    <div>
                      <input
                        type="radio"
                        value="daily"
                        id="daily"
                        name="recurring"
                        color="#242B40"
                        checked={recurring == "daily" ? true : false}
                        inputProps={{
                          readOnly: isEdit
                            ? false
                            : recurring
                            ? recurring == "daily"
                              ? true
                              : false
                            : false,
                        }}
                        onChange={(e) => this.changeRecurring(e)}
                      />
                      <label for="daily">Daily</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        value="weekly"
                        id="weekly"
                        name="recurring"
                        color="#242B40"
                        checked={recurring == "weekly" ? true : false}
                        inputProps={{
                          readOnly: isEdit
                            ? false
                            : recurring
                            ? recurring == "weekly"
                              ? true
                              : false
                            : false,
                        }}
                        onChange={(e) => this.changeRecurring(e)}
                      />
                      <label for="weekly">Weekly</label>
                    </div>
                    {/* <div>
                      <input
                        type="radio"
                        value="monthly"
                        id="monthly"
                        name="recurring"
                        checked={recurring == "monthly" ? true : false}
                        disabled={
                          isEdit
                            ? false
                            : recurring
                            ? recurring == "monthly"
                              ? false
                              : true
                            : true
                        }
                        color="#242B40"
                        onChange={(e) => this.changeRecurring(e)}
                      />
                      <label for="monthly">Monthly</label>
                    </div> */}
                  </div>
                </GridItem>
              </GridItem>
              <GridItem
                className="date_text"
                md={12}
                style={{ marginTop: "20px" }}
              >
                <InputLabel shrink={true}>
                  Select Flight Date &amp; Time
                </InputLabel>
                <DatePicker
                  selected={selectedDate}
                  showTimeSelect={true}
                  dateFormat="LLL"
                  disabled={!isEdit && !addCategory}
                  // timeIntervals={10}
                  minDate={new Date()}
                  onChange={(date) => {
                    this.setState({
                      selectedDate: date,
                      filterDate: date,
                    });
                  }}
                  placeholderText="Select Date"
                />
              </GridItem>
              <GridItem xs={12} className="new_Card">
                {(addCategory || isEdit) && (
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                )}
              </GridItem>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
